import React from "react";

// Centralised provider-icon registry. Used by:
//   - api-credentials.js (Connect modal + credential list rows)
//   - oauth-apps.js (provider configuration cards + edit modal header)
//
// The fallback BADGE letters render as text inside the same circular frame
// so an unknown provider still gets a sensible visual placeholder.

import slackIcon from "../../../../assets/providers/slack.svg";
import googleIcon from "../../../../assets/providers/google.svg";
import notionIcon from "../../../../assets/providers/notion.svg";
import githubIcon from "../../../../assets/providers/github.svg";
import microsoftIcon from "../../../../assets/providers/microsoft.svg";

export const PROVIDER_ICONS = {
  slack: slackIcon,
  google: googleIcon,
  notion: notionIcon,
  github: githubIcon,
  microsoft: microsoftIcon,
};

export const PROVIDER_BADGE_LETTERS = {
  slack: "SL",
  google: "GO",
  notion: "NO",
  github: "GH",
  microsoft: "MS",
};

export function ProviderBadge({ providerId, size = 36 }) {
  const icon = PROVIDER_ICONS[providerId];
  return (
    <span className="gwConnectProviderBadge" style={{ width: size, height: size }}>
      {icon ? (
        <img src={icon} alt="" />
      ) : (
        <span>{PROVIDER_BADGE_LETTERS[providerId] || providerId?.slice(0, 2).toUpperCase() || "??"}</span>
      )}
    </span>
  );
}
